export default __webpack_public_path__ + "static/Group 429-9d019c429e8bd64c79acd51134a47753.png";